// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-html ol {\n  list-style: decimal;\n  margin: revert;\n  padding: revert;\n}\n.v-html ul {\n  list-style: disc;\n  margin: revert;\n  padding: revert;\n}\n.v-html table {\n  width: 100%;\n}\n.v-html table td {\n  border: 1px solid #bfbfbf;\n}\n.v-html h1 {\n  font-size: 24px;\n}\n.v-html h2 {\n  font-size: 21px;\n}\n.v-html h3 {\n  font-size: 16.38px;\n}\n.v-html h4 {\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
